import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "./images/logo.svg";
import styles from "./css/landPage.module.scss";
import text2 from "./images/text2.png";
import downBtn from "./images/downBtn.png";
import newBanner1 from "./images/newBanner1.png";
import Footer from "./Footer.jsx";
import FooterLp from "./FooterLp.jsx";

const yaml = require("js-yaml");

const baseUrl = "https://tool.yunqiboyuan.com/";
const timestamp = new Date().getTime();
const ymlUrl = `${baseUrl}upload/appversion/latest.yml?v=${timestamp}`;
const getyqvidUrl = `${baseUrl}/wapapi/operation/getyqvid`;
const downPostUrl = `${baseUrl}/wapapi/operation/record`;
var yqvid = '';
const LandPager = () => {
  const navigate = useNavigate();
  const handleNavigate = (path) => {
    navigate(path);
  };

  const [app_name, setApp_name] = useState("");
  const [downloadUrl, setDownloadUrl] = useState("");

  useEffect(() => {
    fetchAndParseYaml(ymlUrl);
  }, []);

  console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$")

  async function fetchAndParseYaml(url) {
    console.log("url-----------------------", url);
    try {
      // 发送 HTTP GET 请求获取 YAML 文件内容
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.text();
      // 解析 YAML 内容
      const config = yaml.load(data);
      // 读取并打印 path 字段
      const filePath = config?.path;
      console.log("Path:", filePath);
      setDownloadUrl(`${baseUrl}upload/appversion/${filePath}`);
      setApp_name(filePath);
    } catch (e) {
      console.error("读取或解析 YAML 文件时出错:", e);
    }
  }

  const getStr4 = () => {
      return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
  }
  const getUuid = () => {
      return (getStr4()+getStr4()+getStr4()+getStr4()+getStr4()+getStr4()+getStr4()+getStr4());
  }

  async function getyqvid () {
    const locationHref = new URL(window.location.href);
    const bdvid = locationHref.searchParams.get("bd_vid");
    if(!bdvid) {return}
    const response = await fetch(getyqvidUrl, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        "bdvid": bdvid,
        "logidurl": locationHref.href,
      }),
    });
    const data = await response.text();
    // 解析 YAML 内容
    const config = yaml.load(data);
    yqvid = config.data.yqvid;
  }
  getyqvid();

  const download = async () => {
    console.log("下载11111111111111-------------------------------------")
    const downurl = '/upload/yunqi-zip-decompression-1.1.14_OFFICIAL-114.exe'
    const a = document.createElement("a");
    a.href = downurl;
    a.download = 'yunqi-zip-decompression_YQTG-' + yqvid + '.exe';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    try {
      // 发送 HTTP GET 请求获取 YAML 文件内容
      const response = fetch(downPostUrl, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          "t": 1,
          "p": 1,
          "op": "download",
          "sc": 1,
          "ot": 0,
          "v": "YQTG",
          "sv": "",
          "oc": timestamp,
          "cn": "YQTG",
          "uuid": getUuid(),
          "yqvid": yqvid
        })
      });
      
    } catch (e) {
      console.error("读取或解析 YAML 文件时出错:", e);
    }
  };
  const hostUrl = window.location.href;
  let title = "云启zip解压缩工具"
  if (hostUrl.includes('pdf')){
    title = '云启PDF解压缩工具'
  }
  if (hostUrl.includes('image')){
    title = '云启图片解压缩工具'
  }

  if (hostUrl.includes('video')){
    title = '云启视频解压缩工具'
  }
  

  return (
    <>
      <header className={styles.header}>
        <div className={styles.logo}>
          {/* <img src={logo} title="logo" /> */}
        </div>

        {/* <div className={styles.nav}>
          <span style={{ color: "#ff4338" ,marginRight:'45px'}} onClick={() => handleNavigate("/")}>首页</span>
          <span style={{ marginRight:'45px'}} onClick={() => handleNavigate("/helper")}>使用帮助</span>
          <span onClick={() => handleNavigate("/about")}>关于我们</span>
        </div> */}
      </header>
      <main className={styles.main}>
        <div className={styles.titleCon}>云启zip解压缩工具</div>
        <div className={styles.imgCon}><img className={styles.text2} src={text2} alt="" /></div>
        <div className={styles.imgCon}><img className={styles.mainBtn} src={downBtn} alt="" onClick={() => download()} /></div>
        <img className={styles.newBanner1} src={newBanner1} alt="" />
        <div className={styles.footerCon}>
          <div className={styles.textCon} onClick={() => download()}>解压文件</div>
          <div className={styles.lineCon}></div>
          <div className={styles.textCon} onClick={() => download()}>压缩文件</div>
          <div className={styles.lineCon}></div>
          <div className={styles.textCon} onClick={() => download()}>图片压缩</div>
          <div className={styles.lineCon}></div>
          <div className={styles.textCon} onClick={() => download()}>视频压缩</div>
          <div className={styles.lineCon}></div>
          <div className={styles.textCon} onClick={() => download()}>音频压缩</div>
          <div className={styles.lineCon}></div>
          <div className={styles.textCon} onClick={() => download()}>文档压缩</div>
        </div>
      </main>
      <FooterLp />
    </>
  );
};

export default LandPager;
